
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tours/[slug]",
      function () {
        return require("private-next-pages/tours/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tours/[slug]"])
      });
    }
  